import $ from "jquery";
import { MagnificPopup } from "../../Assets/javascripts/common/dynamic-imports/MagnificPopup";


const magnificPopup = new MagnificPopup();

$('.js-showOrderRegularizationPopin').on('click', function (e) {
  e.preventDefault();
  magnificPopup.open({
    items: {
      src: $('.js-OrderRegularizationPopin'),
      type: 'inline'
    }
  });
});
